const doc = [({"zh_cn":({"labelTop":({"company":"公司名称", "email":"电子邮件地址", "firstname":"名字", "lastname":"姓氏", "phone":"电话号码"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;